import { css } from '@emotion/css';
import { id, SingleSelect } from 'Shared/forms/Inputs'
import { labelStyle } from 'Shared/forms/Wrap'
import { ColourSettingControls } from 'Shared/backend/settingsPage/ColourSetting';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { createMemo } from 'solid-js';
import { Sides } from 'Shared/backend/styles/Sides';
import { Amount } from 'Shared/forms/Amount';
import { subdoc } from 'Common/ViewUtils';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';



export function Borders()
{
	return (
		<StyleFieldsRow>
			<BorderFields />
		</StyleFieldsRow>
	);
}


/* The borders on their own, for a caller that names the location itself - see ruleProperties(). */
export function BorderFields()
{
	const gridStyle = css({
		width: 0,
		display: 'grid',
		gridTemplateColumns: 'auto auto auto auto',
		columnGap: '1em',
		rowGap: '1em',
		alignItems: 'flex-start'
	});

	const sw = useStore();
	/* A bare string colour, which resolveColour() reads as a literal - the shape a border carried
	   before it could link to the palette. */
	const defaults = () => ({style:'solid',width:'1px',colour:'#ccc'});

	return (
		<Sides
			label=''
			property='border'
			settings={BorderSettings}
			defaults={defaults}
			sides={(subdoc(sw.store, sw.location ?? []) as any)?.border?.sides}
			style={gridStyle}
		/>
	);
}

function BorderSettings(P:{label:string,name:string})
{
	const sw = useStore();

	const location = () => [...sw.location,'border',P.name];

	const currentStyle = createMemo(() => (subdoc(sw.store, location()) as any)?.style);

	return (
		<StoreProvider {...sw} location={location()}>
			<label class={labelStyle()} for={id('style')}>{P.label}</label>

			<SingleSelect field='style' required={true} options={{
				none: 'none',
				solid:'solid',
				dotted: 'dotted',
				dashed: 'dashed',
				double: 'double',
				groove: 'groove',
				ridge: 'ridge',
				inset: 'inset',
				outset: 'outset',
				hidden: 'hidden',
			}} />

			<StoreProvider {...sw} location={[...location(),'colour']}>
				<ColourSettingControls notes='' />
			</StoreProvider>

			<Amount field='width' options={{em:'em',px:'px',percent:'%'}} />
		</StoreProvider>
	);
}

